module.exports = __webpack_public_path__ + "img/espaco1.dcc0262d.jpg";